// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ITitleStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    nMVTISTitleStatusTypeCode: string;
    nMVTISTitleStatusTypeDisplayValue: string;
    sortOrder: number;
    active: boolean;
}

export class TitleStatusType implements ITitleStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public nMVTISTitleStatusTypeCode: string;
    public nMVTISTitleStatusTypeDisplayValue: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Active TitleStatusType
	**/
    get Active(): ITitleStatusType {
        return this.FromId(1);
    }
    /**
		Returns Canceled TitleStatusType
	**/
    get Canceled(): ITitleStatusType {
        return this.FromId(2);
    }
    /**
		Returns Revoked TitleStatusType
	**/
    get Revoked(): ITitleStatusType {
        return this.FromId(3);
    }
    /**
		Returns Suspended TitleStatusType
	**/
    get Suspended(): ITitleStatusType {
        return this.FromId(4);
    }
    /**
		Returns Transferred TitleStatusType
	**/
    get Transferred(): ITitleStatusType {
        return this.FromId(5);
    }
    /**
		Returns Vehicle Reported Sold Out of State by Owner TitleStatusType
	**/
    get VehicleReportedSoldOutofStatebyOwner(): ITitleStatusType {
        return this.FromId(6);
    }
    /**
		Returns Duplicated TitleStatusType
	**/
    get Duplicated(): ITitleStatusType {
        return this.FromId(7);
    }
    /**
		Returns Voided TitleStatusType
	**/
    get Voided(): ITitleStatusType {
        return this.FromId(8);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Active', displayValue: 'Active', description: 'Active', nMVTISTitleStatusTypeCode: '00', nMVTISTitleStatusTypeDisplayValue: 'Active', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Canceled', displayValue: 'Canceled', description: 'Canceled', nMVTISTitleStatusTypeCode: '03', nMVTISTitleStatusTypeDisplayValue: 'Canceled', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Revoked', displayValue: 'Revoked', description: 'Revoked', nMVTISTitleStatusTypeCode: '13', nMVTISTitleStatusTypeDisplayValue: 'Revoked', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Suspended', displayValue: 'Suspended', description: 'Suspended', nMVTISTitleStatusTypeCode: '16', nMVTISTitleStatusTypeDisplayValue: 'Suspended', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Transferred', displayValue: 'Transferred', description: 'Transferred', nMVTISTitleStatusTypeCode: '3 ', nMVTISTitleStatusTypeDisplayValue: 'Canceled', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'VehicleReportedSoldOutofStatebyOwner', displayValue: 'Vehicle Reported Sold Out of State by Owner', description: 'Vehicle Reported Sold Out of State by Owner', nMVTISTitleStatusTypeCode: '17', nMVTISTitleStatusTypeDisplayValue: 'Vehicle Reported Sold Out of State by Owner', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'Duplicated', displayValue: 'Duplicated', description: 'Duplicated', nMVTISTitleStatusTypeCode: '97', nMVTISTitleStatusTypeDisplayValue: 'Canceled', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'Voided', displayValue: 'Voided', description: 'Voided', nMVTISTitleStatusTypeCode: '', nMVTISTitleStatusTypeDisplayValue: '', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ITitleStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ITitleStatusType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ITitleStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ITitleStatusType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ITitleStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
